const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

const MondayConfig = {
  CLIENT_ID: CLIENT_ID,
  MONDAY_API_VERSION: "2023-10",
};

export default MondayConfig;
